import * as exBootstrap from '../../bootstrap';

// ----------------------------------------------------------------------------

function show(element: HTMLElement, config: Record<string, any> = {}): void {
    exBootstrap.show('Tooltip', element, config);
}

function hide(element: HTMLElement, config: Record<string, any> = {}): void {
    exBootstrap.hide('Tooltip', element, config);
}

function dispose(element: HTMLElement, config: Record<string, any> = {}): void {
    exBootstrap.dispose('Tooltip', element, config);
}

// ----------------------------------------------------------------------------

export { show, hide, dispose };
